import React, { useEffect, useState, useRef } from 'react'
import './Leftbar.css'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowRightFromBracket,
  faBars,
  faDollarSign,
  faTowerBroadcast,
  faUserAlt
} from '@fortawesome/free-solid-svg-icons'
import { faCommentDots } from '@fortawesome/free-regular-svg-icons'
import logo from '../Images/newlogo.svg'
import { getAuth, signOut } from 'firebase/auth'
import { getDatabase, ref, onValue } from 'firebase/database'

function LeftBar() {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = getAuth()
  const rtdb = getDatabase()

  const [unreadCount, setUnreadCount] = useState(0)
  const [realUnread, setRealUnread] = useState(0)
  const [pulse, setPulse] = useState(false)
  const prevUnreadRef = useRef(0)

  useEffect(() => {
    const user = auth.currentUser
    if (!user) return

    const chatsRef = ref(rtdb, 'chats')
    const lastReadRef = ref(rtdb, 'lastRead')

    let chatsData = {}
    let lastReadData = {}

    const calculateUnread = () => {
      let count = 0

      Object.keys(chatsData).forEach(chatId => {
        if (!chatId.includes(user.uid)) return

        const messages = Object.values(chatsData[chatId] || {})
        if (messages.length === 0) return

        const lastRead = lastReadData?.[chatId]?.[user.uid] || 0

        messages.forEach(msg => {
          if (msg.receiverId === user.uid && msg.timestamp > lastRead) {
            count += 1
          }
        })
      })

      if (count > prevUnreadRef.current) {
        setPulse(true)
        setTimeout(() => setPulse(false), 600)
      }

      prevUnreadRef.current = count
      setRealUnread(count)

      if (location.pathname !== '/messages') {
        setUnreadCount(count)
      }
    }

    const unsubChats = onValue(chatsRef, snap => {
      chatsData = snap.val() || {}
      calculateUnread()
    })

    const unsubLastRead = onValue(lastReadRef, snap => {
      lastReadData = snap.val() || {}
      calculateUnread()
    })

    return () => {
      unsubChats()
      unsubLastRead()
    }
  }, [auth, rtdb, location.pathname])

  useEffect(() => {
    if (location.pathname === '/messages') {
      setUnreadCount(0)
    } else {
      setUnreadCount(realUnread)
    }
  }, [location.pathname, realUnread])

  const logoutUser = () => {
    signOut(auth).then(() => navigate('/'))
  }

  return (
    <div className='leftbar'>
      <div className='logocontainer'>
        <img src={logo} />
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/dashboard" className='leftNavLinks'>
          <FontAwesomeIcon icon={faBars} className='laftNavIcon' />
          Home
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/campaigns" className='leftNavLinks'>
          <FontAwesomeIcon icon={faTowerBroadcast} className='laftNavIcon' />
          Campaigns
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/earnings" className='leftNavLinks'>
          <FontAwesomeIcon icon={faDollarSign} className='laftNavIcon' />
          Earnings
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/messages" className='leftNavLinks'>
          <FontAwesomeIcon icon={faCommentDots} className='laftNavIcon' />
          Messages
          {unreadCount > 0 && (
            <span className={`messageBadge ${pulse ? 'pulse' : ''}`}>
              {unreadCount}
            </span>
          )}
        </NavLink>
      </div>

      <div className='leftLinkCont d-flex align-items-center'>
        <NavLink to="/profile" className='leftNavLinks'>
          <FontAwesomeIcon icon={faUserAlt} className='laftNavIcon' />
          Profile
        </NavLink>
      </div>

      <hr />

      <div className='logoutMenu' onClick={logoutUser}>
        <div className='leftLinkCont d-flex align-items-center'>
          <div className='leftNavLinks logoutbtn'>
            <FontAwesomeIcon icon={faArrowRightFromBracket} className='laftNavIcon' />
            Logout
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftBar